import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: "ar",
    supportedLngs: ["ar", "en"],
    load: "languageOnly",
    detection: {
      order: [
        "cookie",
        "htmlTag",
        "localStorage",
        "sessionStorage",
        "navigator",
        "path",
        "subdomain",
      ],
      caches: ["cookie"],
    },
    backend: {
        // Query string busts a stale translation.json that browsers cached
        // from an earlier deploy — new keys otherwise stay in English.
        loadPath: `${process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_URL || 'http://nova-canary-panle.test')}/frontend/build/locale/{{lng}}/translation.json?v=20260917`,
    },
  });

export default i18n;
